import { useEffect, useState, useCallback } from 'react';
import WebSocketClient, { WebsocketMessage } from './websocket';
import { useAuth } from '@features/auth';
import { API_URL_WS } from '@constants';

export const useWebSocket = () => {
  const [lastMessage, setLastMessage] = useState<WebsocketMessage | null>(null);
  const { state } = useAuth();

  // Get WebSocketClient instance only when accessToken is not null
  const wsClient = useCallback(() => {
    if (state.accessToken) {
      return WebSocketClient.getInstance(API_URL_WS, state.accessToken);
    }
    return null;
  }, [API_URL_WS, state.accessToken]);

  useEffect(() => {
    const client = wsClient();
    if (client) {
      // Subscribe to messages
      const unsubscribe = client.onMessage((msg: WebsocketMessage) => {
        setLastMessage(msg);
      });
      client.connect();
      return () => {
        unsubscribe();
        // client.close();
      };
    }
  }, [wsClient]);

  const sendMessage = useCallback(
    (message: string) => {
      const client = wsClient();
      if (client) {
        client.send(message);
      } else {
        console.log('WebSocket client not initialized. Cannot send message.');
      }
    },
    [wsClient]
  );

  return { sendMessage, lastMessage };
};